import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import objectPath from 'object-path';
import Button from '../button';
import Carousel from '../carousel';
import LazyImg from '../lazy-img';

const carouselStyles = `
  margin-top: 180px;

  ${screen.below(bp.laptopSm, `
    margin-top: 120px;
  `)}

  ${screen.below(bp.mobileSm, `
    margin-top: 80px;
  `)}
`;

const PurposeCarousel = ({ slides }) => {
  if (!slides || slides.length < 1) return null;

  return (
    <Carousel styles={carouselStyles} prevNextButtons>

      {slides.map((slide) => {
        const { leftImage, leftImageButtonLink, leftImageButtonText } = slide.fields;

        return (
          <SlideGrid key={slide.sys.id}>

            <SlideFigure large>
              {objectPath.has(leftImage, 'fields.photo.fields.file.url') &&
                <LazyImg
                  src={`${leftImage.fields.photo.fields.file.url}?w=900&h=700&q=88&fm=jpg&fl=progressive&fit=thumb`}
                  alt={leftImage.fields.photo.fields.description}
                  width={900}
                  height={700}
                />
              }

              {objectPath.has(leftImage, 'fields.photoCaption') &&
                <SlideCaption>{leftImage.fields.photoCaption}</SlideCaption>
              }

              {leftImageButtonLink && leftImageButtonText &&
                <Slidecta>
                  <PurposeButton href={leftImageButtonLink}>
                    {leftImageButtonText}
                  </PurposeButton>
                </Slidecta>
              }
            </SlideFigure>

            {objectPath.has(slide, 'fields.rightImages') && slide.fields.rightImages.map((rightSlide) => {
              if (!objectPath.has(rightSlide, 'fields.photo.fields.file.url')) return null;

              return (
                <SlideFigure key={rightSlide.sys.id}>
                  <LazyImg
                    src={`${rightSlide.fields.photo.fields.file.url}?w=380&h=286&q=88&fm=jpg&fl=progressive&fit=thumb`}
                    alt={rightSlide.fields.photo.fields.description}
                    styles="width: 100%; height: 100%"
                  />

                  {rightSlide.fields.photoCaption &&
                    <SlideCaption>{rightSlide.fields.photoCaption}</SlideCaption>
                  }
                </SlideFigure>
              );
            })}

          </SlideGrid>
        );
      })}

    </Carousel>
  );
};

const SlideGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: repeat(2, 1fr);
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  padding: 0 10px;
  width: 73%;

  ${screen.below(bp.laptopSm, `
    width: 80%;
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    padding: 0 5px;
  `)}

  ${screen.below(bp.mobile, `
    width: calc(100% - 80px);
  `)}

  ${css`
    ${props => screen.below(bp.mobileSm, `
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, auto);
      transition: opacity .5s ease;
      opacity: ${props.index === props.activeSlide ? 1 : '.3'};
    `)}
  `}
`;

const SlideFigure = styled.figure`
  overflow: hidden;
  position: relative;

  ${props => props.large && css`
    grid-row: 1 / span 2;

    ${screen.below(bp.mobileSm, `
      grid-row: 1;
      grid-column: 1 / span 2;
    `)}
  `}
`;

const Slidecta = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const SlideCaption = styled.figcaption`
  position: absolute;
  top: 40px;
  left: 20px;
  line-height: 1;
  font-family: ${props => props.theme.condensedFont};
  font-size: ${rem(14)};
  color: #fff;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  text-align: right;

  ${screen.below(bp.laptopSm, `
    top: 15px;
    left: 10px;
  `)}

  ${screen.below(bp.mobile, `
    display: none;
  `)}
`;

const PurposeButton = styled(Button)`
  ${screen.below(bp.mobile, `
    width: 164px;
  `)}
`;

PurposeCarousel.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.object),
};

export default PurposeCarousel;
